import { render, staticRenderFns } from "./ClientEditModal.vue?vue&type=template&id=41aa4740&scoped=true"
import script from "./ClientEditModal.vue?vue&type=script&lang=ts"
export * from "./ClientEditModal.vue?vue&type=script&lang=ts"
import style0 from "./ClientEditModal.vue?vue&type=style&index=0&id=41aa4740&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41aa4740",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41aa4740')) {
      api.createRecord('41aa4740', component.options)
    } else {
      api.reload('41aa4740', component.options)
    }
    module.hot.accept("./ClientEditModal.vue?vue&type=template&id=41aa4740&scoped=true", function () {
      api.rerender('41aa4740', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyProjects/ClientEditModal.vue"
export default component.exports